'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var indentRe = /^((\t|  )+)/mg;
var tabRe = /\t/g;

var normalizeCode = function normalizeCode(code) {
  return code.replace(indentRe, function (_, indentation) {
    return indentation.replace(tabRe, '  ');
  });
};

exports.default = normalizeCode;


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/~/react-code-editor/lib/utils/normalizeCode.js